// extracted by mini-css-extract-plugin
export var fullHeightState = "_1m-7";
export var headerCell = "_1m-1";
export var loadingStateCell = "_1m-4";
export var rowWrapper = "_1m-3";
export var standaloneTable = "_1m-8";
export var standaloneTableWithBodyFill = "_1m-9";
export var stateCell = "_1m-5";
export var table = "_1m-0";
export var tableBodyFiller = "_1m-6";
export var white = "_1m-2";